export default __webpack_public_path__ + "static/media/bz.eb28b1b6.svg";